import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import './Navigation.scss';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import {
    getAccountType,
    getCustomAccess,
    getFullName,
    getIsEnabledForVTerm,
    getIsLoading as getIsSelfLoading,
    getPayoutAccountAccessRights,
    getRole
} from '../Self/selfEntity';
import { getAccountName, getEmail } from '../UserData/userDataEntity';
import { getIsNavigationOpen, getShouldReloadFraudCount, getShouldReloadPendingCount } from './viewState';
import { closeNavigation } from './actions';
import { logout } from '../Login/loginActions';
import { getFraudCount as fetchFraudCount } from '../Fraud/fraudActions';
import { getPendingCount as fetchPendingCount } from '../PayoutBatches/payoutBatchesActions';
import { getIsMerchantsLoaded } from '../Merchants/merchantsEntity';
import { getFraudCount, getFraudCountErrorMessage, getIsFraudCountLoading } from '../Fraud/fraudEntity';
import { getPendingCount, getPendingCountErrorMessage, getIsPendingCountLoading } from '../PayoutBatches/payoutBatchesEntity';
import { getSelectedMerchantIdsString } from '../MerchantSelector/merchantSelectorViewState';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { toastIfError } from '../../utils/toast';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { getIsReserveSummariesLoading, getReserveSummaries } from '../Reserves/reservesEntity';
import { getReserveSummaries as fetchReserveSummaries } from '../Reserves/reservesActions';
import _ from 'lodash';
import { getExportsAvailable, getIsExportsAvailableLoading } from '../Exports/exportsEntity';
import { getAvailableExports } from '../Exports/exportsActions';
import { locationShape } from '../../utils/propTypes';
import { getPayoutAccountsThatRequireBatchReview } from '../PayoutAccounts/payoutAccountEntity';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export class Navigation extends Component {
    static propTypes = {
        accountType: PropTypes.string,
        doesPayoutAccountRequireReview: PropTypes.bool,
        email: PropTypes.string,
        fraudCount: PropTypes.number,
        fraudCountError: PropTypes.string,
        pendingCount: PropTypes.number,
        pendingCountError: PropTypes.string,
        fullName: PropTypes.string,
        hasPayoutAccounts: PropTypes.bool,
        isFraudCountLoading: PropTypes.bool,
        isPendingCountLoading: PropTypes.bool,
        isMerchantsLoaded: PropTypes.bool,
        isNavigationOpen: PropTypes.bool,
        isReserveSummariesLoading: PropTypes.bool,
        isAvailableExportsLoading: PropTypes.bool,
        isSelfLoading: PropTypes.bool,
        merchantSelector: PropTypes.node,
        onClose: PropTypes.func.isRequired,
        onGetFraudCount: PropTypes.func.isRequired,
        onGetPendingCount: PropTypes.func.isRequired,
        onGetReserveSummaries: PropTypes.func.isRequired,
        onGetAvailableExports: PropTypes.func.isRequired,
        onLogout: PropTypes.func.isRequired,
        reserveSummaries: PropTypes.array,
        availableExports: PropTypes.array,
        selectedMerchantIds: PropTypes.string,
        selectedPayoutAccountIds: PropTypes.string,
        shouldReloadFraudCount: PropTypes.bool,
        shouldReloadPendingCount: PropTypes.bool,
        isEnabledForVTerm: PropTypes.bool,
        customRole: PropTypes.string,
        routesList: PropTypes.any,
        customAccess: PropTypes.any,
        location: locationShape,
        paymentServiceMerchants: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {
        };

        this.navigationItems = this.setNavigationItems(props);
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'fraudCountError');
        toastIfError(prevProps, this.props, 'pendingCountError');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'customAccess')) {
            this.forceUpdate();
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'accountName')) {
            this.navigationItems = this.setNavigationItems(this.props);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selectedMerchantIds') ||
            doesPropExistAndHasItChanged(prevProps, this.props, 'shouldReloadFraudCount') ||
            doesPropExistAndHasItChanged(prevProps, this.props, 'shouldReloadPendingCount') ||
            doesPropExistAndHasItChanged(prevProps, this.props, 'routesList')) {
            this.navigationItems = this.setNavigationItems(this.props);

            if (_.get(this.props.routesList, 'exports.canAccess')) {
                this.props.onGetAvailableExports();
            }

            if (_.get(this.props.routesList, 'fraud.canAccess')) {
                this.props.onGetFraudCount(this.props.selectedMerchantIds);
            }

            if (_.get(this.props.routesList, 'reserves.canAccess')) {
                this.props.onGetReserveSummaries(this.props.selectedMerchantIds);
            }

            if (_.get(this.props.routesList, 'payouts.canAccess')) {
                this.props.onGetPendingCount(this.props.selectedPayoutAccountIds);
            }
        }

        if ((doesPropExistAndHasItChanged(prevProps, this.props, 'email') && this.props.email) ||
            doesPropExistAndHasItChanged(prevProps, this.props, 'isSelfLoading') ||
            doesPropExistAndHasItChanged(prevProps, this.props, 'flags')) {
            this.navigationItems = this.setNavigationItems(this.props);

        }
    }

    setNavigationItems = (props) => {
        return [
            {
                label: 'Home',
                shouldRender: this.props.accountType === 'RESELLER',
                resellerRoutes: [
                    {
                        icon: <span className="material-icons">home</span>,
                        label: 'Portfolio Overview',
                        route: _.get(props.routesList, 'home.route'),
                        shouldRender: props.flags?.resellerPhase1 && _.get(props.routesList, 'home.canAccess')
                    },
                    {
                        icon: <span className="material-icons">verified_user</span>,
                        label: 'Pre-Vets',
                        route: `${_.get(props.routesList, 'pathToLive.route')}?tab=prevet&status=`,
                        shouldRender: _.get(props.routesList, 'pathToLive.canAccess')
                    },
                    {
                        icon: <span className="material-icons">list_alt</span>,
                        label: 'Applications',
                        route: `${_.get(props.routesList, 'pathToLive.route')}?tab=applications&status=`,
                        shouldRender: _.get(props.routesList, 'pathToLive.canAccess')
                    },
                    {
                        icon: <span className="material-icons">how_to_reg</span>,
                        label: 'Approved Merchants',
                        route: `${_.get(props.routesList, 'pathToLive.route')}?tab=merchants&status=`,
                        shouldRender: _.get(props.routesList, 'pathToLive.canAccess')
                    },
                    {
                        icon: <span className="material-icons">home</span>,
                        label: 'Overview',
                        route: _.get(props.routesList, 'homeLegacy.route'),
                        shouldRender: !props.flags?.resellerPhase1 && _.get(props.routesList, 'homeLegacy.canAccess')
                    },
                    {
                        icon: <span className="material-icons">domain</span>,
                        label: 'Boarding Status',
                        route: _.get(props.routesList, 'processorOnboardingStatus.route'),
                        shouldRender: !props.flags?.resellerPhase1 && _.get(props.routesList, 'processorOnboardingStatus.canAccess')
                    },
                    {
                        icon: <span className="material-icons">attach_money</span>,
                        label: 'Residual Report',
                        route: _.get(props.routesList, 'residuals.route'),
                        shouldRender: !props.flags?.resellerPhase1 && _.get(props.routesList, 'residuals.canAccess')
                    }
                ]
            },
            {
                icon: <span className="material-icons">dashboard</span>,
                label: 'Merchant Dashboard',
                route: _.get(props.routesList, 'dashboard.route'),
                shouldRender: !props.flags?.resellerPhase1 && _.get(props.routesList, 'dashboard.canAccess')
            },
            {
                icon: <span className="material-icons">payments</span>,
                label: 'Virtual Terminal',
                labelSuffix: <span className="material-icons">open_in_new</span>,
                tooltipId: 'virtual-terminal-nav-tooltip',
                title: 'Opens in a new tab.',
                route: {
                    pathname: _.get(props.routesList, 'virtualTerminal.route'),
                    state: { openVirtualTerminalTab: true }
                },
                shouldRender: props.isEnabledForVTerm && _.get(props.routesList, 'virtualTerminal.canAccess')
            },
            {
                icon: <span className="material-icons">list</span>,
                label: 'Transactions',
                route: _.get(props.routesList, 'transactions.route'),
                shouldRender: !props.flags?.resellerPhase1 && _.get(props.routesList, 'transactions.canAccess')
            },
            {
                icon: <span className="material-icons">local_atm</span>,
                isActive: (match, location) => (
                    location.pathname.includes('/payouts/')
                ),
                label: 'Payout Reports',
                route: _.get(props.routesList, 'payouts.route'),
                shouldRender: props.hasPayoutAccounts,
                subRoutes: [
                    {
                        label: 'Payouts',
                        route: _.get(props.routesList, 'payouts.route'),
                        shouldRender: _.get(props.routesList, 'payouts.canAccess')
                    },
                    {
                        label: 'Batches',
                        route: _.get(props.routesList, 'payoutBatches.route'),
                        shouldRender: _.get(props.routesList, 'payoutBatches.canAccess')
                    },
                    {
                        label: 'Pending Batches',
                        notificationsKey: 'pendingCount',
                        notificationsLoadingKey: 'isPendingCountLoading',
                        doesRequireAsyncData: true,
                        dataKey: 'payoutAccountsThatRequireBatchReview',
                        route: _.get(props.routesList, 'pendingPayoutBatches.route'),
                        shouldRender: _.get(props.routesList, 'pendingPayoutBatches.canAccess')
                    },
                    {
                        label: 'Recipients',
                        route: _.get(props.routesList, 'payoutRecipients.route'),
                        shouldRender: _.get(props.routesList, 'payoutRecipients.canAccess')
                    },
                    {
                        label: 'Spendbacks',
                        route: _.get(props.routesList, 'spendbacks.route'),
                        shouldRender: _.get(props.routesList, 'spendbacks.canAccess')
                    }
                ]
            },
            {
                icon: <span className="material-icons">insert_chart_outlined</span>,
                isActive: (match, location) => (
                    location.pathname.includes('/reports/')
                ),
                label: 'Reports',
                route: _.get(props.routesList, 'depositSummary.route'),
                shouldRender: true,
                subRoutes: [
                    {
                        label: 'Residuals',
                        route: _.get(props.routesList, 'residuals.route'),
                        shouldRender: props.flags?.resellerPhase1 && _.get(props.routesList, 'residuals.canAccess')
                    },
                    {
                        label: 'Transaction Details',
                        route: _.get(props.routesList, 'transactions.route'),
                        shouldRender: props.flags?.resellerPhase1 && _.get(props.routesList, 'transactions.canAccess')
                    },
                    {
                        label: 'Deposit Summaries',
                        route: _.get(props.routesList, 'depositSummary.route'),
                        shouldRender: _.get(props.routesList, 'depositSummary.canAccess')
                    },
                    {
                        label: 'Chargebacks',
                        route: _.get(props.routesList, 'chargebacks.route'),
                        shouldRender: _.get(props.routesList, 'chargebacks.canAccess')
                    },
                    {
                        label: 'Adjustments',
                        route: _.get(props.routesList, 'adjustments.route'),
                        shouldRender: _.get(props.routesList, 'adjustments.canAccess')
                    },
                    {
                        label: 'Batch Details',
                        route: _.get(props.routesList, 'batchDetails.route'),
                        shouldRender: _.get(props.routesList, 'batchDetails.canAccess')
                    },
                    {
                        label: 'Statements',
                        route: _.get(props.routesList, 'statements.route'),
                        shouldRender: _.get(props.routesList, 'statements.canAccess')
                    },
                    {
                        label: 'Fraud',
                        route: _.get(props.routesList, 'fraud.route'),
                        shouldRender: _.get(props.routesList, 'fraud.canAccess'),
                        notificationsKey: 'fraudCount',
                        notificationsLoadingKey: 'isFraudCountLoading'
                    },
                    {
                        label: 'Reserves',
                        route: _.get(props.routesList, 'reserves.route'),
                        shouldRender: _.get(props.routesList, 'reserves.canAccess'),
                        doesRequireAsyncData: true,
                        dataKey: 'reserveSummaries'
                    }
                ]
            },
            {
                icon: <span className="material-icons">download</span>,
                label: 'Large Exports',
                route: _.get(props.routesList, 'exports.route'),
                shouldRender: _.get(props.routesList, 'exports.canAccess'),
                doesRequireAsyncData: true,
                dataKey: 'availableExports'
            },
            //Empty to gain a seperator
            {
                label: 'Separator'
            },
            {
                label: 'Footer',
                shouldRender: true,
                footerRoutes: [
                    {
                        icon: <span className="material-icons">account_circle</span>,
                        label: props.isSelfLoading && !props.email
                            ? <LoadingSpinner size="small" invert relative />
                            : props.email,
                        route: '/settings/details',
                        shouldRender: true
                    },
                    {
                        icon: <span className="material-icons">settings</span>,
                        label: 'Settings',
                        route: _.get(props.routesList, 'settings.route'),
                        shouldRender: true
                    },
                    {
                        icon: <span className="material-icons">forum</span>,
                        label: 'Support',
                        route: _.get(props.routesList, 'support.route'),
                        shouldRender: true
                    },
                    {
                        action: this.props.onLogout,
                        icon: <span className="material-icons">cancel</span>,
                        label: 'Logout'
                    }
                ]
            }
        ];
    };

    handleCollapseNavListClick = (item, e) => {
        e.preventDefault();
        if (item.subRoutes) {
            const isCollapsedKey = `is${item.label}Collapsed`;

            this.setState({ [isCollapsedKey]: !this.state[isCollapsedKey] });
        }
    };

    getLogoTargetRoute = () => {
        const routesList = this.props.routesList || {};
        const preferredHomeRoute = ['home', 'homeLegacy', 'dashboard'];

        for (const key of preferredHomeRoute) {
            const routeConfig = routesList[key];
            const canAccess = routeConfig && routeConfig.canAccess;
            const routePath = routeConfig && routeConfig.route;

            if (canAccess && typeof routePath === 'string' && routePath.length > 0) {
                return routePath;
            }
        }

        return '/';
    };

    handleLogoClick = (e) => {
        e.preventDefault();
        const targetRoute = this.getLogoTargetRoute();

        if (this.props.history && targetRoute) {
            this.props.history.push(targetRoute);
        }
    };

    renderNotification(item) {
        if (item.notificationsKey) {
            return this.props[item.notificationsLoadingKey]
                ? <LoadingSpinner relative invert size="small" />
                : this.props[item.notificationsKey];
        }
    }

    renderNavigationItem(item) {
        if (item.isLoading) {
            return [
                <div key={item.label + 'icon'} className="emvio-navigation-icon">
                    {item.icon}
                </div>,
                <div key={item.label + 'label'} className="emvio-navigation-content-text">
                    <span className="emvio-navigation-content-text-inner">
                        {item.label}{item.labelSuffix}
                    </span>
                </div>
            ];
        }

        const notification = item.notificationsKey && this.props[item.notificationsKey] > 0
            ? <div key={item.label + 'notifications'} className={`emvio-navigation-content-notification ${item.notificationsKey}`}>
                {this.renderNotification(item)}
            </div>
            : null;

        return [
            <div key={item.label + 'icon'} className="emvio-navigation-icon">
                {item.icon}
            </div>,
            <div key={item.label + 'label'} className="emvio-navigation-content-text">
                <span className="emvio-navigation-content-text-inner">
                    {item.label}{item.labelSuffix}
                </span>
            </div>,
            notification
        ];
    }

    renderResellerItems(navigationItems, onClose) {
        const resellerItems = _.filter(navigationItems, 'resellerRoutes');

        return resellerItems.map((resellerItem) => {
            if (!resellerItem.shouldRender) {
                return null;
            }

            return resellerItem.resellerRoutes.map((resellerRoute) => {
                return this.renderNavigationLink(resellerRoute, onClose);
            });
        });
    }

    renderNavigationLink(item, onClose, isSubRoute) {
        const hasAsyncData = _.size(this.props[item.dataKey]);

        if (!item.shouldRender) {
            return null;
        }

        const routePath = typeof item.route === 'string' ? item.route : item.route?.pathname;

        return (item.route && (!item.doesRequireAsyncData || hasAsyncData)
            ? <span
                className="nav-link"
                key={item.label || routePath}
                {...(item.tooltipId && {
                    'data-tooltip-id': item.tooltipId,
                    'data-tooltip-place': item.tooltipPlace || 'right',
                    'data-tooltip-position-strategy': 'fixed'
                })}>
                <NavLink
                    className={classNames('emvio-navigation-content', {
                        'emvio-routes-header': item.subRoutes,
                        'emvio-sub-route': isSubRoute
                    })}
                    activeClassName="active-link"
                    isActive={item.isActive}
                    key={item.label}
                    exact to={item.route}
                    onClick={onClose}>
                    {this.renderNavigationItem(item)}
                </NavLink>
                {item.subRoutes
                    ? <span className={classNames('icon-caret-down', {
                        'is-collapsed': this.state[`is${item.label}Collapsed`]
                    })} onClick={(e) => this.handleCollapseNavListClick(item, e)} />
                    : null}
                {item.tooltipId && item.title && typeof document !== 'undefined'
                    ? ReactDOM.createPortal(
                        <ReactTooltip
                            id={item.tooltipId}
                            content={item.title}
                            place="right"
                            positionStrategy="fixed"
                        />,
                        document.body
                    )
                    : null}
            </span>
            : null
        );
    }

    renderFooterLinks(item, onClose) {
        return item.footerRoutes.map((footerRoute) => {
            if (footerRoute.action) {
                return <div className="emvio-navigation-content logout" key={footerRoute.label} onClick={footerRoute.action}>
                    {this.renderNavigationItem(footerRoute)}
                </div>;
            } else {
                return this.renderNavigationLink(footerRoute, onClose);
            }
        });
    }

    renderSubRouteLinks(navigationItem, onClose) {
        return _.filter(navigationItem.subRoutes,
            (subRoute) => subRoute.shouldRender)
            .map((subRoute) => this.renderNavigationLink(subRoute, onClose, true));
    }

    renderNavigationItems = (navigationItems, onClose) => {
        return navigationItems.map((navigationItem) => {
            const subRouteLinks = this.renderSubRouteLinks(navigationItem, onClose);

            if (!navigationItem.shouldRender || (navigationItem.subRoutes && _.isEmpty(subRouteLinks))) {
                return null;
            }

            return <span key={navigationItem.label} className={classNames('nav-item', {
                'list-header': subRouteLinks
            })}>
                {this.renderNavigationLink(navigationItem, onClose)}
                {!_.isEmpty(subRouteLinks) ? <div className={classNames('sub-route-list', {
                    'is-collapsed': this.state[`is${navigationItem.label}Collapsed`]
                })}>{subRouteLinks}</div> : null}
            </span>;
        });
    };

    renderFooterRoutes(navigationItems, onClose) {
        const footers = _.filter(navigationItems, 'footerRoutes');

        return footers.map((footer) => {
            return this.renderFooterLinks(footer, onClose);
        });
    }

    render() {
        let sideClass = classNames('emvio-navigation', {
            'emvio-layout-side-close': !this.props.isNavigationOpen,
            'emvio-layout-side-open': this.props.isNavigationOpen
        });

        return (
            <div className={sideClass}>
                <div className="emvio-navigation-container">
                    <div className="emvio-navigation-main">
                        <div className="emvio-navigation-content-container">
                            <div className="emvio-navigation-logo-container">
                                <a href="/" onClick={this.handleLogoClick}>
                                    <div className="emvio-navigation-logo"></div>
                                </a>
                            </div>
                            <div className="emvio-navigation-reseller">
                                {this.renderResellerItems(this.navigationItems, this.props.onClose)}
                            </div>
                            {!this.props.flags?.resellerPhase1 && this.props.merchantSelector}
                            <div className="emvio-navigation-reports">
                                {this.renderNavigationItems(this.navigationItems, this.props.onClose)}
                            </div>
                            <div className="emvio-navigation-bottom-seperator">{this.item}</div>
                            <div className="emvio-navigation-footer">
                                {this.renderFooterRoutes(this.navigationItems, this.props.onClose)}
                            </div>
                        </div>
                    </div>
                    <div className="emvio-navigation-close-bar" onClick={this.props.onClose}>
                        <div className="emvio-navigation-close-btn">
                            <span className="icon-close" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountName: getAccountName(state),
        accountType: getAccountType(state),
        email: getEmail(state),
        payoutAccountsThatRequireBatchReview: getPayoutAccountsThatRequireBatchReview(state),
        fraudCount: getFraudCount(state),
        fraudCountError: getFraudCountErrorMessage(state),
        pendingCount: getPendingCount(state),
        pendingCountError: getPendingCountErrorMessage(state),
        fullName: getFullName(state),
        hasPayoutAccounts: getPayoutAccountAccessRights(state),
        isFraudCountLoading: getIsFraudCountLoading(state),
        isPendingCountLoading: getIsPendingCountLoading(state),
        isMerchantsLoaded: getIsMerchantsLoaded(state),
        isNavigationOpen: getIsNavigationOpen(state),
        isReserveSummariesLoading: getIsReserveSummariesLoading(state),
        isAvailableExportsLoading: getIsExportsAvailableLoading(state),
        isSelfLoading: getIsSelfLoading(state),
        reserveSummaries: getReserveSummaries(state),
        availableExports: getExportsAvailable(state),
        selectedMerchantIds: getSelectedMerchantIdsString(state),
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        shouldReloadFraudCount: getShouldReloadFraudCount(state),
        shouldReloadPendingCount: getShouldReloadPendingCount(state),
        isEnabledForVTerm: getIsEnabledForVTerm(state),
        customRole: getRole(state),
        customAccess: getCustomAccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onClose: () => dispatch(closeNavigation()),
        onGetFraudCount: (merchantIds) => dispatch(fetchFraudCount(merchantIds)),
        onGetPendingCount: (payoutAccountIds) => dispatch(fetchPendingCount(payoutAccountIds)),
        onGetReserveSummaries: (merchantIds) => dispatch(fetchReserveSummaries(merchantIds)),
        onGetAvailableExports: () => dispatch(getAvailableExports()),
        onLogout: () => dispatch(logout())
    };
}

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation)));
